import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import api, { fmtErr } from "../api";
import AuthShell, { darkInput, darkLabel } from "../components/AuthShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return setError("Adresse e-mail invalide.");
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      title="Mot de passe oublié"
      subtitle="Saisissez votre e-mail pour recevoir un lien de réinitialisation sécurisé."
      footer={<Link to="/login" className="font-semibold text-cyan-400 hover:text-cyan-300" data-testid="back-to-login-link">← Retour à la connexion</Link>}
    >
      {done ? (
        <div className="rounded-lg border border-cyan-400/30 bg-cyan-500/10 px-4 py-5 text-center" data-testid="forgot-success">
          <MailCheck className="mx-auto h-8 w-8 text-cyan-400" />
          <p className="mt-3 text-sm text-slate-200">
            Si un compte existe pour <span className="font-semibold text-cyan-300">{email}</span>, un lien de réinitialisation vient d'être envoyé.
          </p>
          <p className="mt-2 text-xs text-slate-500">Le lien est valable 1 heure. Vérifiez vos spams si besoin.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className={darkLabel}>Adresse e-mail</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="vous@entreprise.com" className={darkInput} data-testid="forgot-email-input" />
          </div>
          {error && <p className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="forgot-error">{error}</p>}
          <Button type="submit" disabled={submitting}
            className="w-full bg-cyan-500 font-semibold text-[#05070B] hover:bg-cyan-400" data-testid="forgot-submit-button">
            {submitting ? "Envoi…" : "Envoyer le lien de réinitialisation"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
